import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export function AnalyticsAccess({ isAuthenticated, children }) {
  const location = useLocation();
  return isAuthenticated ? children : <Navigate to="/password_user" replace state={{ analyticsReturnTo: location.pathname }} />;
}

export function AnalyticsSignInReturn() {
  const { state } = useLocation();
  const path = state?.analyticsReturnTo;
  const safePath = typeof path === 'string' && /^\/dashboard_user(?:\/(?:compliance|engagement|leaderboard|help))?\/?$/.test(path);
  return <Navigate to={safePath ? path : '/homepage_user'} replace />;
}
